/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime : 2020-01-09 17:45:33
 * @LastEditors  : cc
 * @FilePath: \xjmediacloud\app\networkResource\featuredResource\toutiao\toutiao_router.js
 * @Description: 头条稿件路由
 */
'use strict';
angular.module('resCenToutiaoRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.featuredresource.toutiao.resource', {
                url: '/resource?typename&nodeid&nodename',
                views: {
                    'networksource@front.networksource.featuredresource.toutiao': {
                        templateUrl: './networkResource/featuredResource/toutiao/toutiao_main_tpl.html',
                        controller: 'resCenToutiaoCtrl',
                    },
                },
            })
            .state('front.networksource.featuredresource.toutiao.quickpreview', {
                url: '/quickpreview?typename&nodeid&nodename&guid',
                views: {
                    'networksource@front.networksource.featuredresource.toutiao': {
                        templateUrl: './networkResource/featuredResource/toutiao/quickPreview/main_tpl.html',
                        controller: 'toutiaoQuickPreviewCtrl',
                    },
                },
            });
    },
]);
